export default __webpack_public_path__ + "static/subjunctive-71184214a806aee1a97693fa48ba9422.svg";